// @ts-nocheck
import { ControlledCheckbox } from './common/Checkbox/Checkbox'
import { ControlledCombobox } from './common/Combobox/Combobox'
import { ControlledRadio } from './common/Radio/Radio'
import { ControlledEditors } from './common/Editors/Editors'
import { ControlledFile } from './common/File/File'
import { ControlledInput } from './common/Input/Input'
import { ControlledScore } from './common/Score/Score'
import { ControlledSlider } from './common/Slider/Slider'
import { ControlledSwitch } from './common/Switch/Switch'
import { ControlledTextarea } from './common/Textarea/Textarea'

export const CHECKBOX_FIELD = 'checkbox'
export const COMBOBOX_FIELD = 'combobox'
export const RADIO_FIELD = 'radio'
export const EDITOR_FIELD = 'editor'
export const FILE_FIELD = 'file'
export const INPUT_FIELD = 'input'
export const SCORE_FIELD = 'score'
export const SLIDER_FIELD = 'slider'
export const SWITCH_FIELD = 'switch'
export const TEXTAREA_FIELD = 'textarea'

export const getField = type => {
  const fields = {
    [CHECKBOX_FIELD]: ControlledCheckbox,
    [COMBOBOX_FIELD]: ControlledCombobox,
    [RADIO_FIELD]: ControlledRadio,
    [FILE_FIELD]: ControlledFile,
    [INPUT_FIELD]: ControlledInput,
    [EDITOR_FIELD]: ControlledEditors,
    [SCORE_FIELD]: ControlledScore,
    [SLIDER_FIELD]: ControlledSlider,
    [SWITCH_FIELD]: ControlledSwitch,
    [TEXTAREA_FIELD]: ControlledTextarea,
  }

  return fields[type]
}
